import axios from "axios"
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { connectNode } from '../../utils/global.js'
const { JWT_CRYPT_KEY } = require("../../const/authKey")

// Authentication service //
class AuthService {
  login(username, password) {
    //return (dispatch) => {
    return axios.post(connectNode + 'auth2/validate2', {
        username: username,
        password: password
      } , {
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Accept: 'application/json'
        }
      }).then(response => {
            //console.log('User-pre: ' + localStorage.getItem("accessUser"))
            //if (response.status === 200) {
            var timeoutTimestamp = new Date().getTime() + 61 * 60 * 1000
            var cookieTimeout = new Date(timeoutTimestamp);
            if (typeof response.data.token !== 'undefined') {
              Cookies.set('c_', response.data.user.uid, {
                expires: cookieTimeout, // 1/48,
              })
              var enc = CryptoJS.AES.encrypt(response.data.token, JWT_CRYPT_KEY).toString()
              Cookies.set('fr', enc, {
                expires: cookieTimeout,
              })
              Cookies.set('co_', response.data.user.course_id, {
                expires: cookieTimeout, // 1/48,
              })
              var payload = {
                uid: response.data.user.uid,
                username: response.data.user.username,
                role: response.data.user.role,
                sub_role: response.data.user.sub_role,
                p_st: response.data.user.status, // patients_registration.status
                b_step: response.data.user.baseline_step, // patients_registration.baseline_step
                a_status: response.data.user.appt_status, // intake appointments.appt_status
                token: enc,
                loggedIn: true,
                expires: response.data.user.expires,
                course_id: response.data.user.course_id,
              }
              return payload
            } else {
              //console.log(response)
              if(response.data.message == 'Lock') {
                return -2
              } else if(response.data.message == 'Attempts lock') {
                return -3
              } else if(response.data.message == 'Disable') {
                return -4
              } else {
                return -1
              }
            }
            //return null
        }).catch(error => {
            console.log(error);
            return {
              success: false,
              networkError: true,
              message: 'Network error'
            }
        })
    //}
  }

  logout() {
    localStorage.removeItem("accessUser")
    Cookies.remove('c_')
    Cookies.remove('fr')
    Cookies.remove('co_')
    //Cookies.remove('cto')
    Cookies.remove('connect.sid')
  }

  register(username, email, password) {
    return axios.post(connectNode + "signup", {
      username,
      email,
      password
    });
  }

  isAuthenticated() {
    return axios.post(connectNode + 'users/profile', {
      //uid: username,
      fr: CryptoJS.AES.decrypt(Cookies.get('fr')).toString(CryptoJS.enc.Utf8)
    } , {
      'Content-Type': 'application/x-www-form-urlencoded',
      //withCredentials: true,
    }).then(response => {
          if (typeof response.data.uid > 0) {
            return true
          }
          return false
      }).catch(error => {
          console.log(error);
          return {
            success: false,
            networkError: true,
            message: 'Network error'
          }
      })
  }
}
export default new AuthService();
